import axios from "axios";
import { useState } from "react";

function useAddressSuggestions() {
  const [addressSuggestions, setAddressSuggestions] = useState([])
  const [isChoosedSuggestion, setIsChoosedSuggestion] = useState(true);

  const API_KEY = "13347789193766472";
  const AUTOCOMPLETE_URL = "https://us-autocomplete.api.smartystreets.com/lookup";

  const fetchAddressSuggestions = async (query) => {
    setIsChoosedSuggestion(false);

    try {
      const response = await axios.get(AUTOCOMPLETE_URL, {
      	params: {
      		key: API_KEY,
      		search: query,
      	},
      });

      setAddressSuggestions(response.data?.suggestions || [])
    } catch (error) {
      setAddressSuggestions([])
    }
  };

  const renderSuggestionsDropdown = (handleSelectAddressSuggestion) => addressSuggestions.length > 0 ? (
    <ul className="autocomplete-suggestions">
      {addressSuggestions.map((sugg, index) => (
        <li key={index} onClick={() => handleSelectAddressSuggestion(sugg)}>
          {`${sugg.street_line}, ${sugg.city}, ${sugg.state}, ${sugg.zipcode}`}
        </li>
      ))}
    </ul>
  ) : null

  return {
    fetchAddressSuggestions,
    addressSuggestions,
    setAddressSuggestions,
    isChoosedSuggestion,
    setIsChoosedSuggestion,
    renderSuggestionsDropdown
  }
}

export default useAddressSuggestions